import jsPDF from "jspdf";
import "jspdf-autotable";
// Date Fns is used to format the dates we receive
// from our API call
import { format } from "date-fns";
import moment from 'moment';
import 'moment/locale/es';
moment.locale('es')
const generatePDFPlaysByCountry = (plays,action) => {
    // initialize jsPDF
    const doc = new jsPDF();
  
    // define the columns we want and their titles
    const tableColumn = ["País","Total",];
    // define an empty array of rows
    const tableRows = [];
  
    // for each ticket pass all its data into an array
    plays.forEach(play => {
      const playData = [
          play.country,
          play['total'],
        // called date-fns to format the date on the ticket
      ];
      // push each tickcet's info into a row
      tableRows.push(playData);
    });
  
  
    // startY is basically margin-top
    moment.locale('es')
    var today = moment(Date.now())
  
    const date = Date().split(" ");
    // we use a date string to generate our filename.
    const dateStr = date[0] + date[1] + date[2] + date[3] + date[4];
    // ticket title. and margin-top + margin-left
  //   doc.text("Closed tickets within the last one month.", 14, 15);
    // we define the name of our PDF file.
    doc.text(`Premio Casa de Composición 2023`, 55, 15);
    doc.text(`${today.format('LL')}`, 80, 25);
    doc.text("Reporte de Obras por países", 8, 30);
    doc.autoTable(tableColumn, tableRows, { startY: 35 });

    // doc.save(`reporte_obras_${dateStr}.pdf`);
  if(action=="save"){
    doc.save(`reporte_obras_pais_${dateStr}.pdf`);
  }
  else{
    doc.setProperties({
      title: `reporte_obras_${dateStr}.pdf`
      });
      doc.output('dataurlnewwindow');
  }
  
    
    // doc.open()
  };
  
  export default generatePDFPlaysByCountry;